import Vue from 'vue';

import {
  getDirectories,
  getDirectory,
  updateDirectory,
  createDirectory,
  deleteDirectory,
} from '@/services/directories';

export const state = {
  loading: false,
  directory: {},
  directories: {},
};

export const mutations = {
  toggleUpdating(state) {
    state.loading = !state.loading;
  },

  setDirectory(state, directory) {
    state.directory = directory;
  },

  setDirectories(state, directories) {
    Vue.set(state, 'directories', {});
    directories.forEach(directory => {
      Vue.set(state.directories, directory.id, directory);
    });
  },

  deleteDirectory(state, directoryId) {
    Vue.delete(state.directories, directoryId);
  },
};

export const getters = {
  getDirectories: state => filter => {
    let directories = Object.values(state.directories);
    if (!(Array.isArray(directories) && directories.length)) {
      return directories;
    }

    directories = sortDirectories(directories);

    return directories.filter(directory =>
      directory?.name.toLowerCase().includes(filter.toLowerCase())
    );
  },
  getCurrentDirectory: state => {
    return JSON.parse(JSON.stringify(state.directory));
  },
};

export const actions = {
  setDirectory({ commit, rootState }, directory) {
    directory.entries.forEach(entry => {
      const user = rootState.users.index[entry.username];
      entry.user = user;
    });

    commit('setDirectory', directory);
  },

  getDirectories({ commit }) {
    return getDirectories().then(response => {
      commit('setDirectories', response.data);
    });
  },

  getDirectory({ dispatch, commit }, { directoryId }) {
    commit('toggleUpdating');
    return getDirectory(directoryId).then(response => {
      dispatch('setDirectory', response.data);
      commit('toggleUpdating');
    });
  },

  updateDirectory({ getters, commit, dispatch }, directory) {
    commit('toggleUpdating');

    return updateDirectory(directory)
      .then(r => {
        dispatch('setDirectory', r.data);
        dispatch('getDirectories');
        return Promise.resolve(r);
      })
      .catch(error => {
        return Promise.reject(error);
      })
      .finally(() => {
        commit('toggleUpdating');
      });
  },

  addDirectoryEntry({ dispatch }, { directory, entry }) {
    directory.entries = [
      ...directory.entries,
      {
        description: entry.description,
        user: entry.user,
        order: directory.entries.length + 1,
        ...entry.user,
      },
    ];
    return dispatch('updateDirectory', directory);
  },

  updateDirectoryEntry({ dispatch }, { directory, entry }) {
    directory.entries = directory.entries.map(localEntry =>
      localEntry.id === entry.id ? entry : localEntry
    );
    return dispatch('updateDirectory', directory);
  },

  deleteDirectoryEntry({ dispatch }, { directory, entry }) {
    directory.entries = directory.entries.filter(
      localEntry => localEntry.id !== entry.id
    );

    // we should tidy the order up here
    directory.entries
      .sort((a, b) => {
        return a.order - b.order;
      })
      .forEach((entry, index) => {
        entry.order = index;
      });

    return dispatch('updateDirectory', directory);
  },

  unselectDirectory({ commit }) {
    commit('setDirectory', null);
  },

  createDirectory({}, { directoryName }) {
    return createDirectory(directoryName);
  },

  deleteDirectory({ commit }, { directory }) {
    deleteDirectory(directory.id).then(() => {
      commit('deleteDirectory', directory.id);
    });
  },
};

function sortDirectories(directories) {
  directories = directories.sort((a, b) => a.name.localeCompare(b.name));
  const globalElement = directories.find(
    directory => directory.is_global === true
  );
  directories = directories.filter(directory => directory.is_global === false);
  directories.splice(0, 0, globalElement);

  return directories;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
